import { render } from "./ProjectsGallery.vue?vue&type=template&id=ef0c98cc&scoped=true&ts=true"
import script from "./ProjectsGallery.vue?vue&type=script&lang=ts"
export * from "./ProjectsGallery.vue?vue&type=script&lang=ts"

import "./ProjectsGallery.vue?vue&type=style&index=0&id=ef0c98cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0c98cc"]])

export default __exports__